/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import { Box, TextField } from '@mui/material';
import { CustomFieldConditionValue, CustomFieldValueShape } from '../typings';

interface Props {
  shape: CustomFieldValueShape;
  value: CustomFieldConditionValue;
  onChange: (next: CustomFieldConditionValue) => void;
}

const parseNumber = (raw: string): number | '' => {
  if (raw.trim() === '') return '';
  const n = Number(raw);
  return Number.isFinite(n) ? n : '';
};

const NumberValueInput = ({ shape, value, onChange }: Props) => {
  if (shape === 'BETWEEN') {
    const start = value.type === 'BETWEEN' ? value.start : '';
    const end = value.type === 'BETWEEN' ? value.end : '';
    return (
      <Box
        css={css`
          display: flex;
          gap: 8px;
        `}
      >
        <TextField
          fullWidth
          size="small"
          type="number"
          placeholder="From"
          value={start}
          onChange={(e) => onChange({ type: 'BETWEEN', start: parseNumber(e.target.value), end })}
          InputProps={{ sx: { fontSize: 14 } }}
        />
        <TextField
          fullWidth
          size="small"
          type="number"
          placeholder="To"
          value={end}
          onChange={(e) => onChange({ type: 'BETWEEN', start, end: parseNumber(e.target.value) })}
          InputProps={{ sx: { fontSize: 14 } }}
        />
      </Box>
    );
  }
  const single = value.type === 'VALUE' && typeof value.value === 'number' ? value.value : '';
  return (
    <TextField
      fullWidth
      size="small"
      type="number"
      placeholder="Enter value"
      value={single}
      onChange={(e) => onChange({ type: 'VALUE', value: parseNumber(e.target.value) as number })}
      InputProps={{ sx: { fontSize: 14 } }}
    />
  );
};

export default memo(NumberValueInput);
